import { createContext } from "react";

export interface JWTContextType<T extends object = object> {}

const AuthContext = createContext<JWTContextType>({} as JWTContextType);

export default AuthContext;
